module.exports = __webpack_public_path__ + "static/media/exhibition-services-img17.a1d72154.jpg";